import { render, staticRenderFns } from "./ggReleaseRange.vue?vue&type=template&id=dd154ef2&scoped=true&"
import script from "./ggReleaseRange.vue?vue&type=script&lang=js&"
export * from "./ggReleaseRange.vue?vue&type=script&lang=js&"
import style0 from "./ggReleaseRange.vue?vue&type=style&index=0&id=dd154ef2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd154ef2",
  null
  
)

export default component.exports